import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Stack } from '@hub/stack';
import { forwardRef } from '@hub/design-system-base';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * NOTE: This is a simplified implementation of `@hub/reel` with very specific
 * styling applied suitable only for the collection-deck. Do not use this
 * component anywhere outside of the collection-deck.
 */
export const Reel = forwardRef((_ref, reelRef) => {
  let {
    as,
    minWidth = 'size-auto',
    maxWidth = 'size-auto',
    gap = 'spacing-none',
    className,
    snap,
    children,
    flexBasis = minWidth,
    shouldWrapChildren,
    sx
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    ref: reelRef,
    as: as,
    direction: "row",
    className: className,
    minWidth: minWidth,
    maxWidth: maxWidth,
    flexBasis: flexBasis,
    gap: gap,
    shouldWrapChildren: shouldWrapChildren,
    sx: _objectSpread(_objectSpread({
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      msOverflowStyle: 'none' /* IE and Edge */,
      scrollbarWidth: 'none' /* Firefox */,
      overflowX: 'auto'
    }, snap && {
      scrollBehavior: 'smooth',
      scrollSnapType: 'x mandatory'
    }), sx),
    "data-id": "collection-deck_reel_Reel_Stack",
    children: React.Children.map(children, child => {
      var _child$props$sx, _child$props;
      return /*#__PURE__*/React.isValidElement(child) && /*#__PURE__*/React.cloneElement(child, {
        sx: _objectSpread(_objectSpread({}, snap && {
          scrollSnapAlign: 'start'
        }), (_child$props$sx = child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.sx) !== null && _child$props$sx !== void 0 ? _child$props$sx : {})
      });
    })
  });
});